<template>
  <div class="color-selector">
    <div
      v-if="label"
      class="cs-handle"
    >
      <span class="cs-label">{{ label }}</span>
      <span
        v-if="selectedItem"
        class="cs-selected-item"
        >{{ selectedItem.title }}</span
      >
    </div>

    <div class="cs-colors">
      <div
        v-for="item in items"
        :key="item.value"
        class="cs-color"
        :class="{
          'cs-color--selected': item.value === unref(model),
        }"
        :style="{
          backgroundColor: item.color,
        }"
        :title="item.title"
        tabindex="0"
        @click.prevent="onInput(item.value)"
        @keydown.enter="onInput(item.value)"
        @keydown.space.prevent="onInput(item.value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    items: Array<any>;
    label?: string;
  }>(),
  {
    label: null,
  },
);

const emit = defineEmits(['input']);
const model = defineModel<string>('value');

const selectedItem = computed(() => {
  return props.items.filter((item) => item.value === model.value)[0];
});

const onInput = (itemValue) => {
  // Update model with the selected item
  model.value = itemValue;

  // Emit 'input' event for backwards compat
  emit('input', itemValue);
};
</script>

<style lang="scss" scoped>
.color-selector {
  position: relative;
  display: block;
  overflow: hidden;
  z-index: 1;

  .cs-handle {
    font-size: map-get($font-sizes, 'm');
    margin-bottom: math.div($pad, 4);
  }

  .cs-selected-item {
    font-weight: bold;
  }

  .cs-colors {
    display: flex;
    margin: 0 (-$pad);
  }

  .cs-color {
    position: relative;
    display: block;
    width: $pad;
    height: $pad;
    border-radius: 100%;
    background-color: palette(grey);
    margin: math.div($pad, 2) $pad;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      display: block;
      left: -4px;
      top: -4px;
      z-index: -1;
      width: $pad * 1.5;
      height: $pad * 1.5;
      background-color: $color-general-background-neutral-default;
      border: 2px solid palette(red);
      border-radius: 100%;
      cursor: pointer;
      opacity: 0;
      transition: 0.1s ease-in opacity;
    }

    &:focus,
    &:hover {
      outline: 0;

      &:before {
        opacity: 0.25;
      }
    }

    &.cs-color--selected {
      &:before {
        opacity: 1;
      }
    }
  }
}
</style>
